import st from "lib/utils/index";
import { serializeAgentCooperation } from "lib/utils/api/serializers";
import { AgentCooperationDecorator, AgentCooperationFullDecorator } from "lib/decorators/index";
import BaseRepository from "./BaseRepository";

export default new (class AgentCooperationsRepository extends BaseRepository {
  findAll(params = {}) {
    const bucket = this.getBucket("agent_cooperations.index");
    const request$ = this.api.get(`/agent_cooperations`, { params }).map((response) => ({
      records: st.api
        .dejsonapinize(response.data.data, response.data.included)
        .map((coop) => new AgentCooperationDecorator(coop)),
      meta: response.data.meta,
    }));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }

  find(id) {
    return this.api
      .get(`/agent_cooperations/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((coop) => new AgentCooperationFullDecorator(coop));
  }

  create({ agent_email, supplier_email }) {
    // debugger;
    return this.api
      .post(`/agent_cooperations`, { agent_email, supplier_email })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((coop) => new AgentCooperationFullDecorator(coop));
  }

  update(data, initialData) {
    return this.api
      .put(`/agent_cooperations/${data.id}`, {
        agent_cooperation: serializeAgentCooperation(data, initialData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((coop) => new AgentCooperationFullDecorator(coop));
  }

  delete(id) {
    return this.api.delete(`/agent_cooperations/${id}`);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/AgentCooperationsRepository.js